(() => {
  'use strict';
  const offset = 4 * 60 * 60 * 1000;
  function dayStart(value) {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return NaN;
    const [year, month, day] = value.split('-').map(Number);
    const date = new Date(Date.UTC(year, month - 1, day));
    if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return NaN;
    return date.getTime() - offset;
  }
  function eligible(campaign, context, now) {
    if (!campaign || campaign.active !== true) return false;
    if (campaign.id == null || typeof campaign.heading !== 'string' || !campaign.heading.trim()) return false;
    if (context.editor === true && context.previewId) return String(campaign.id) === String(context.previewId);
    if (campaign.enabled !== true) return false;
    const start = dayStart(campaign.start), end = dayStart(campaign.end);
    if (!Number.isFinite(start) || !Number.isFinite(end) || end < start || now < start || now >= end + 86400000) return false;
    if (campaign.target === 'all') return true;
    if (campaign.target === 'home') return context.type === 'index';
    if (campaign.target !== 'selected') return false;
    if (context.type === 'index' && campaign.home === true) return true;
    const lists = {page: campaign.pages, product: campaign.products, collection: campaign.collections};
    return !!context.id && Array.isArray(lists[context.type]) && lists[context.type].some(id => String(id) === String(context.id));
  }
  function winner(campaigns, context, now, format, placement = 'main') {
    const candidates = campaigns.filter(c => c.format === format && eligible(c, context, now) && (format !== 'banner' || (c.placement || 'main') === placement));
    return candidates.sort((a, b) => (Number(b.priority) || 0) - (Number(a.priority) || 0) || (String(a.id) < String(b.id) ? -1 : String(a.id) > String(b.id) ? 1 : 0))[0] || null;
  }
  const sessionKey = campaign => 'mbl-seasonal-v1:' + campaign.id + ':' + (campaign.version || '1');
  globalThis.MBLSeasonalCore = Object.freeze({dayStart, eligible, winner, sessionKey});
})();
